import React, { memo } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import { createStructuredSelector } from "reselect";
import { makeSelectSessionToken } from "ducks/selectors";
import SmartRender from "containers/SmartRender";
import {
  clearData,
  fetchSecuredPaymentRequest,
  postPaymentRequest
} from "ducks/actions";
import {
  makeSelectPaymentRequest,
  makeSelectOrderSummaryFormInitialValues,
  makeSelectWireCardOneTimePaymentForm
} from "ducks/selectors";
import usePaymentResponseHandler from "hooks/usePaymentResponseHandler";
import { urlParam } from "utils/helpers";
import { forms } from "utils/constants";

const WireCardOneTimePayment = Component =>
  function Comp(props) {
    const enhancedProps = {
      ...props,
      order: { order_ref: urlParam("order_ref") },
      token: 123
    };
    //added dummy value 123 as token is not required in this flow

    return <Component {...enhancedProps} />;
  };

const mapStateToProps = createStructuredSelector({
  token: makeSelectSessionToken(),
  paymentRequest: makeSelectPaymentRequest(),
  formValues: makeSelectWireCardOneTimePaymentForm(),
  initialValues: makeSelectOrderSummaryFormInitialValues()
});

export const mapDispatchToProps = dispatch => {
  return {
    clearPaymentRequest: () => {
      dispatch(clearData("paymentRequest"));
    },
    fetchPaymentRequest: params => {
      dispatch(fetchSecuredPaymentRequest(params));
    },
    onSubmit: (_, payload) => {
      dispatch(postPaymentRequest(payload, usePaymentResponseHandler));
    }
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(
  withConnect,
  reduxForm({
    form: forms.WIRECARD_ONE_TIME_PAYMENT_FORM,
    destroyOnUnmount: false,
    enableReinitialize: true
  }),
  memo
)(WireCardOneTimePayment(SmartRender));
